import { useEffect, useRef, useState } from "react"
import type { QueryKey } from "@tanstack/react-query"
import { atom, useAtomValue, useSetAtom } from "jotai"
import type { Event } from "@apps/gwservice/types"
import { EventCard } from "./event-card"
import { EventListHeader } from "./event-list-header"
import { EventSheet } from "./event-sheet"

export const selectedDayAtom = atom(new Date())

type Props = {
  events: Event[]
  queryKey: QueryKey
  eventId?: number
  onConsumeEventId?: () => void
}

export function EventList({ events, queryKey, eventId, onConsumeEventId }: Props) {
  const selectedDay = useAtomValue(selectedDayAtom)
  const setSelectedDay = useSetAtom(selectedDayAtom)
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null)
  const consumed = useRef(false)

  useEffect(() => {
    if (consumed.current || !eventId) return
    const target = events.find((e) => e.id === eventId)
    if (!target) return
    consumed.current = true
    setSelectedDay(target.date)
    setSelectedEvent(target)
    onConsumeEventId?.()
  }, [eventId, events, setSelectedDay, onConsumeEventId])

  const filtered = events.filter((event) => event.date.toDateString() === selectedDay.toDateString())

  return (
    <div className="flex-1 px-m flex flex-col">
      <EventListHeader date={selectedDay} count={filtered.length} />
      {filtered.length === 0
        ? <p className="flex-1 flex items-center justify-center text-base text-muted-foreground">На этот день нет событий</p>
        : <div className="flex flex-col">{filtered.map((event) => <EventCard key={event.id} event={event} onClick={() => setSelectedEvent(event)} />)}</div>}
      <EventSheet event={selectedEvent} onClose={() => setSelectedEvent(null)} queryKey={queryKey} />
    </div>
  )
}
